import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/auth'
import settings from '@/settings'
import moment from 'moment'
import vuetify from './plugins/vuetify'
import './RegisterServiceWorker'

moment.locale('pt-br')
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp(settings.firebaseConfig)
  },
  // mounted () {
  //   firebase.auth().onAuthStateChanged((user) => {
  //     this.$store.dispatch('userChanged', user)
  //   })
  // }
}).$mount('#app')
